// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.limitSelector_box {
    display: flex;
    gap: 8px;
    align-items: center;
}

.limitSelector_box label {
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    white-space: nowrap;
}

.limitSelector_box select {
    padding: 6px 10px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    font-size: 13px;
    color: var(--text-primary);
    background-color: var(--bg-card);
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Filters/LimitSelector/LimitSelector.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,eAAe;AACnB","sourcesContent":[".limitSelector_box {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.limitSelector_box label {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    white-space: nowrap;\n}\n\n.limitSelector_box select {\n    padding: 6px 10px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n    font-size: 13px;\n    color: var(--text-primary);\n    background-color: var(--bg-card);\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
